module.exports = __webpack_public_path__ + "static/media/Distrito-01.c5ea7eb6.png";